import React from "react";
import { Button, Col, Drawer, Row } from "@payping/web-components";
import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import {
  isBusinessRegisterURL,
  isMobileBusinessRegisterURL,
  isMobilePersonalRegisterURL,
  isPersonalRegisterURL,
} from "@/utils/isRegisterURL";

interface Prop {
  onAccept?: () => void;
  onCancel?: () => void;
  loading?: boolean;
  acceptText?: string;
}
const EditActionButtons: React.FC<Prop> = (props) => {
  const { onAccept, onCancel, loading, acceptText } = props;
  const isRegisterURL =
    // checking desktop
    isPersonalRegisterURL() ||
    isBusinessRegisterURL() ||
    // checking is mobile
    isMobilePersonalRegisterURL() ||
    isMobileBusinessRegisterURL();
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  return (
    <Drawer placement={"bottom"} closable={false} mask={false} open={true} height={80}>
      <Row gutter={[8, 8]}>
        <Col flex={3}>
          <Button loading={loading} onClick={onAccept} type={"primary"} className={"tw:w-full"}>
            {acceptText ?? (isRegisterURL ? t("next") : t("save"))}
          </Button>
        </Col>
        <Col flex={1}>
          <Button className={"tw:w-full"} onClick={onCancel || (() => navigate(-1))}>
            {isRegisterURL ? t("previousStep") : t("back")}
          </Button>
        </Col>
      </Row>
    </Drawer>
  );
};

export default EditActionButtons;
